<div *ngIf="!isCookiePolicyPage" id="cookie-consent-container" [ngClass]="{ 'remove-container': removeContainer }">
    <div class="cookie-consent-background">
        <div class="cookie-consent">
            <h1 class="section-title">{{'consentimiento-cookies.titulo' | translate}}</h1>
            <p>{{'consentimiento-cookies.contenido' | translate}}</p>
            <p [innerHTML]="'consentimiento-cookies.politica-cookies' | translate"></p>
            <div class="buttons-container">
                <button class="secondary" (click)="manageCookieConsent(false)">{{'consentimiento-cookies.rechazar' | translate}}</button>
                <button (click)="manageCookieConsent(true)">{{'consentimiento-cookies.aceptar' | translate}}</button>
            </div>
        </div>
    </div>
</div>